module.exports = __webpack_public_path__ + "img/user.0e21ae37.svg";